export default {
  openModal({ commit }, payload) {
    commit('OPEN_MODAL', payload)
  },
  closeModal({ commit }) {
    commit('CLOSE_MODAL')
  },
}
